import React, { useEffect, useState } from "react";

const CommonTemplate = ({ selectedTemplate, selectedLayout, isTemplateId, widgetId, chatTabData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentTime, setCurrentTime] = useState('');
    
    // Default values for the chatTabData
    const {
        is_website_frontend,
        line_id,
        position_alignment_type,
        chat_window_name_color,
        chat_window_caption_color,
        header_background_color,
        online_status_color,
        chat_wallpaper_color,
        message_background_color,
        button_color,
        chat_window_name,
        chat_window_picture,
        chat_window_caption,
        start_chat_button_text,
        welcome_message,
        chat_triggers_is_on_page_load,
        bubble_background_color,
        is_show_bubble_notification_badge,
        bubble_icon_color,
        bubble_text,
        notification_badge_color,
    } = chatTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/line-chat/temp-css/CommonTemplate.css`;
        if (widgetId) {
            link.setAttribute("line-chat-data-dynamic-css", "line-chat");
        } else {
            link.setAttribute("data-dynamic-css", "line-chat");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="line-chat"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    useEffect(() => {
        // Only open popup if page load is enabled and user is NOT from website frontend
        const shouldOpenPopup =
            Number(chat_triggers_is_on_page_load) === 1 &&
           is_website_frontend !== "website-frontend";

        setIsOpen(shouldOpenPopup);
    }, [is_website_frontend,chat_triggers_is_on_page_load]);

    useEffect(() => {
        // Function to update time
        const updateTime = () => {
            const now = new Date();
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = now.getMinutes().toString().padStart(2, '0');
            setCurrentTime(`${hours}:${minutes}`);
        };

        updateTime(); // initial call

        const interval = setInterval(updateTime, 60000);

        return () => clearInterval(interval);
    }, []);

    //Color contrast function
    function getContrastingColor(hexColor) {
        if (!hexColor) return '#000';

        // Remove #
        const color = hexColor.replace('#', '');

        let r, g, b;
        if (color.length === 3) {
            // e.g. #fff → expand to #ffffff
            r = parseInt(color[0] + color[0], 16);
            g = parseInt(color[1] + color[1], 16);
            b = parseInt(color[2] + color[2], 16);
        } else if (color.length === 6) {
            r = parseInt(color.substring(0, 2), 16);
            g = parseInt(color.substring(2, 4), 16);
            b = parseInt(color.substring(4, 6), 16);
        } else {
            return '#000'; // fallback
        }

        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness < 128 ? '#ffffff' : '#000000';
    }
    const iconAndTextColor = getContrastingColor(button_color);

    // Check if chat_window_picture is a File (Blob) and convert it
    const imageUrl = chat_window_picture instanceof File
        ? URL.createObjectURL(chat_window_picture)
        : chat_window_picture || "booking-pro.png";

    return (
        <>
            <div className={`upgadeify-line-chat-template-main ${is_website_frontend}`} >
                <div className={`upgadeify-line-chat-template-inner ${position_alignment_type}`}>

                    {isOpen && (
                        <div className="upgadeify-line-chat-template">
                            <div className="upgadeify-line-chat-avatar-wrapper" style={{ backgroundColor: header_background_color, }}>
                                <div className="upgadeify-line-chat-avatar">
                                    <img src={imageUrl} alt="Avatar" />
                                    <div className="upgadeify-line-chat-online" style={{ backgroundColor: online_status_color }}></div>
                                </div>
                                <div className="upgadeify-line-chat-avatar_content">
                                    <div className="upgadeify-line-chat-avatar_name" style={{color: chat_window_name_color }}>{chat_window_name}</div>
                                    <div className="upgadeify-line-chat-avatar_text" style={{color: chat_window_caption_color }}>{chat_window_caption}</div>
                                </div>
                                <div className="close-chat-poup">
                                    <button onClick={() => setIsOpen(false)}>X</button>
                                </div>
                            </div>
                            <div className="upgadeify-line-chat-template-box" style={{ backgroundColor: chat_wallpaper_color}}>
                                <div className="upgadeify-line-chat-time">
                                    {currentTime}
                                </div>    
                                <div className="upgadeify-line-chat_box">
                                    <div className="upgadeify-line-chat-box_content">
                                        <div className="upgadeify-line-chat-box_text" style={{ backgroundColor: message_background_color}}>
                                           {welcome_message}
                                        </div>
                                    </div>
                                </div>
                                <div className="upgadeify-line-chat_box-button">
                                    <button className="upgadeify-line-chat_box-button" onClick={(e) => {
                                        window.open(
                                            `https://line.me/R/ti/p/${(line_id && line_id.trim()) || 'line'}`,
                                            "_blank",
                                            "width=600,height=600"
                                        );
                                        }} style={{ backgroundColor: button_color,  color: iconAndTextColor}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="injected-svg"><path fill-rule="evenodd" d="M23 9.933C23 4.96 18.05 1 12 1S1 5.052 1 9.933c0 4.421 3.942 8.105 9.167 8.842.366.092.825.276 1.008.552a1.9 1.9 0 0 1 0 1.014s-.092.736-.183.92c-.092.277-.184 1.106.916.553 1.192-.46 6.325-3.776 8.617-6.447C22.175 13.71 23 11.96 23 9.933ZM8.058 12.604c0 .092-.091.185-.183.185H4.758c-.091 0-.091 0-.183-.093 0 0-.092-.092-.092-.184V7.723c0-.092.092-.184.184-.184h.916c.092 0 .184.092.184.184v3.868h2.108c.092 0 .183.092.183.184v.83Zm1.925 0c0 .092-.091.185-.183.185h-.825c-.092 0-.183-.093-.183-.185v-4.88c0-.093.091-.185.183-.185h.733c.092 0 .184.092.184.184v4.881h.091Zm5.317 0c0 .092-.092.185-.183.185h-.825l-.092-.093L12 9.75v2.855c0 .092-.092.185-.183.185h-.734c-.091 0-.183-.093-.183-.185v-4.88c0-.093.092-.185.183-.185h.734l2.2 2.947V7.723c0-.092.091-.184.183-.184h.733c.092 0 .184.092.184.184v4.881h.183Zm4.217-4.052a.198.198 0 0 1-.184.184h-2.108v.83h2.108c.092 0 .184.091.184.183v.83c0 .091-.092.183-.184.183h-2.108v.83h2.108c.092 0 .184.091.184.183v.737a.198.198 0 0 1-.184.184h-3.116c-.092 0-.092 0-.184-.092 0 0-.091-.092-.091-.184V7.723c0-.092 0-.092.091-.184 0 0 .092-.092.184-.092h3.116c.092 0 .184.092.184.184v.921Z" fill={iconAndTextColor}></path></svg> {start_chat_button_text}</button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='upgadeify-line-chat-button'>
                        <button className={`upgadeify-line-button ${bubble_text ? 'bubble-text' : ''}`} onClick={() => setIsOpen(!isOpen)} style={{ backgroundColor: bubble_background_color, color: bubble_icon_color }}>
                            {/* SVG Icon for line Chat Bubble */}
                            {selectedTemplate === 'General_Temp' && (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="injected-svg" className="injected-svg"><path fill-rule="evenodd" d="M23 9.933C23 4.96 18.05 1 12 1S1 5.052 1 9.933c0 4.421 3.942 8.105 9.167 8.842.366.092.825.276 1.008.552a1.9 1.9 0 0 1 0 1.014s-.092.736-.183.92c-.092.277-.184 1.106.916.553 1.192-.46 6.325-3.776 8.617-6.447C22.175 13.71 23 11.96 23 9.933ZM8.058 12.604c0 .092-.091.185-.183.185H4.758c-.091 0-.091 0-.183-.093 0 0-.092-.092-.092-.184V7.723c0-.092.092-.184.184-.184h.916c.092 0 .184.092.184.184v3.868h2.108c.092 0 .183.092.183.184v.83Zm1.925 0c0 .092-.091.185-.183.185h-.825c-.092 0-.183-.093-.183-.185v-4.88c0-.093.091-.185.183-.185h.733c.092 0 .184.092.184.184v4.881h.091Zm5.317 0c0 .092-.092.185-.183.185h-.825l-.092-.093L12 9.75v2.855c0 .092-.092.185-.183.185h-.734c-.091 0-.183-.093-.183-.185v-4.88c0-.093.092-.185.183-.185h.734l2.2 2.947V7.723c0-.092.091-.184.183-.184h.733c.092 0 .184.092.184.184v4.881h.183Zm4.217-4.052a.198.198 0 0 1-.184.184h-2.108v.83h2.108c.092 0 .184.091.184.183v.83c0 .091-.092.183-.184.183h-2.108v.83h2.108c.092 0 .184.091.184.183v.737a.198.198 0 0 1-.184.184h-3.116c-.092 0-.092 0-.184-.092 0 0-.091-.092-.091-.184V7.723c0-.092 0-.092.091-.184 0 0 .092-.092.184-.092h3.116c.092 0 .184.092.184.184v.921Z" fill={bubble_icon_color}></path></svg>
                            )}

                            {selectedTemplate === 'Support_Temp' && (
                               <svg xmlns="http://www.w3.org/2000/svg" fill="#0084ff" viewBox="0 0 32 32" class="injected-svg" data-src="https://static.elfsight.com/icons/app-chats-support-bubble-multicolor.svg" bis_size="{&quot;x&quot;:1261,&quot;y&quot;:636,&quot;w&quot;:20,&quot;h&quot;:20,&quot;abs_x&quot;:1661,&quot;abs_y&quot;:696}"><path d="M32 16c0 8.822-7.178 16-16 16a15.95 15.95 0 0 1-11.308-4.692A15.95 15.95 0 0 1 0 16C0 7.178 7.178 0 16 0s16 7.178 16 16zm-16 7.111A7.12 7.12 0 0 0 23.111 16a7.09 7.09 0 0 0-2.085-5.026A7.09 7.09 0 0 0 16 8.89 7.12 7.12 0 0 0 8.889 16 7.12 7.12 0 0 0 16 23.111zm9.573-16.684a13.576 13.576 0 0 0-5.058-3.197v4.48a9.51 9.51 0 0 1 3.774 3.774h4.481a13.576 13.576 0 0 0-3.197-5.058zM3.23 11.485h4.48a9.51 9.51 0 0 1 3.774-3.774V3.23a13.612 13.612 0 0 0-8.255 8.255zM20.515 24.29v4.481a13.613 13.613 0 0 0 8.255-8.255h-4.48a9.51 9.51 0 0 1-3.774 3.774zm-9.033 0a9.51 9.51 0 0 1-3.774-3.774H3.227a13.613 13.613 0 0 0 8.255 8.255V24.29z" bis_size="{&quot;x&quot;:1261,&quot;y&quot;:636,&quot;w&quot;:20,&quot;h&quot;:20,&quot;abs_x&quot;:1661,&quot;abs_y&quot;:696}"> fill={bubble_icon_color}</path></svg>
                            )}

                            {selectedTemplate === 'Sale_Temp' && (
                              <svg xmlns="http://www.w3.org/2000/svg" fill="#0084ff" viewBox="0 0 32 32" class="injected-svg" data-src="https://static.elfsight.com/icons/app-chats-message-bubble-multicolor.svg" bis_size="{&quot;x&quot;:1353,&quot;y&quot;:469,&quot;w&quot;:32,&quot;h&quot;:32,&quot;abs_x&quot;:1753,&quot;abs_y&quot;:529}"><path d="M2 7.778v17.444C2 26.204 2.796 27 3.778 27h24.444c.982 0 1.778-.796 1.778-1.778V7.778C30 6.796 29.204 6 28.222 6H3.778C2.796 6 2 6.796 2 7.778zm26.083 15.32-7.932-7.795-3.017 2.498a1.778 1.778 0 0 1-2.268 0l-3.017-2.498-7.932 7.796a.089.089 0 0 1-.133-.118l6.75-8.768-6.56-5.574a.089.089 0 0 1 .101-.144l11.035 6.387c.55.319 1.23.319 1.78 0l11.036-6.387a.089.089 0 0 1 .102.144l-6.56 5.574 6.748 8.768a.089.089 0 0 1-.133.118z" bis_size="{&quot;x&quot;:1355,&quot;y&quot;:475,&quot;w&quot;:28,&quot;h&quot;:21,&quot;abs_x&quot;:1755,&quot;abs_y&quot;:535}" fill={bubble_icon_color} ></path></svg>
                            )}

                            {selectedTemplate === 'Booking_Temp' && (
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="injected-svg" data-src="https://static.elfsight.com/icons/appointment.svg"><path d="m16.335 11.566.087.078a1 1 0 0 1 .078 1.327l-.078.087-4.364 4.364a1 1 0 0 1-1.327.078l-.087-.078-2.206-2.165a1 1 0 0 1 1.327-1.492l.088.078L11.35 15.3l3.657-3.656a1 1 0 0 1 1.327-.078z" fill={bubble_icon_color}></path><path fill-rule="evenodd" d="M17.493 2.183A1 1 0 0 0 15.5 2.3v1.1h-7V2.3l-.007-.117A1 1 0 0 0 6.5 2.3v1.1H5.4l-.176.005A3 3 0 0 0 2.4 6.4v13.2l.005.176A3 3 0 0 0 5.4 22.6h13.2l.176-.005A3 3 0 0 0 21.6 19.6V6.4l-.005-.176A3 3 0 0 0 18.6 3.4h-1.1V2.3l-.007-.117zM4.4 9.5h15.2l.001 10.1-.007.117a1 1 0 0 1-.993.883H5.4l-.117-.007A1 1 0 0 1 4.4 19.6L4.399 9.5z" clip-rule="evenodd" fill={bubble_icon_color} ></path></svg>
                            )}

                            {selectedTemplate === 'Feedback_Temp' && (
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="injected-svg" className="injected-svg"><path  d="M.692 10.03a1 1 0 0 0-.099 1.807l5.303 2.855L16.55 6.28a.244.244 0 0 1 .32.368l-9.568 9.103a1 1 0 0 0-.076.377v4.443a.5.5 0 0 0 .918.273l2.516-3.848 5.094 2.412a2 2 0 0 0 2.83-1.489l2.472-15.326a.5.5 0 0 0-.681-.543L.692 10.03z" clip-rule="evenodd" fill={bubble_icon_color}></path></svg>
                            )}

                            {selectedTemplate === 'Onboarding_Temp' && (
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="injected-svg"><g clip-path="url(#a-4)"><path fill-rule="evenodd" d="M1.935 6.274A11.678 11.678 0 0 1 11.7 1h.604c3.936 0 7.607 1.983 9.765 5.274a8.759 8.759 0 0 1 0 9.606 11.678 11.678 0 0 1-9.765 5.274H11.7c-.257 0-.512-.008-.767-.025l-3.635 2.772a.5.5 0 0 1-.803-.398V19.93a11.673 11.673 0 0 1-4.56-4.05 8.759 8.759 0 0 1 0-9.606zm6.764 4.803c0 .928-.74 1.68-1.653 1.68s-1.653-.752-1.653-1.68c0-.928.74-1.68 1.653-1.68s1.653.752 1.653 1.68zm3.303 1.68c.913 0 1.653-.752 1.653-1.68 0-.928-.74-1.68-1.653-1.68-.912 0-1.652.752-1.652 1.68 0 .928.74 1.68 1.652 1.68zm6.61-1.68c0 .928-.74 1.68-1.653 1.68s-1.653-.752-1.653-1.68c0-.928.74-1.68 1.653-1.68s1.653.752 1.653 1.68z" clip-rule="evenodd" fill={bubble_icon_color}></path></g></svg>
                            )}
                                
                            {bubble_text}
                            {Number(is_show_bubble_notification_badge) === 1 && (
                            <div className="upgadeify-line-chat-alert" style={{ backgroundColor: notification_badge_color }}></div>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CommonTemplate;
